import { store } from "../app/store";
import {
  beginGlobalLoading,
  endGlobalLoading,
  setProgress,
  clearProgress,
} from "../features/ui/uiSlice";
import { openAlertError, openAlertSuccess } from "../features/modal/modalSlice";
import { http } from "../lib/http";
import { getPresignedUrl, formatDateForS3, generateS3KeyAuto } from "./s3.prefirma";
import { getLocalStorageUserSession } from "./secureStorage";

type PresignResponse = { bucket: string; urls: { url: string }[] };

interface UploadMediaProps {
  file: File;
}

export const uploadMedia = async ({ file }: UploadMediaProps) => {
  const tmpKey = `upload:${file.name}`;

  store.dispatch(beginGlobalLoading());
  try {
    const date = formatDateForS3();

    const { data } = (await getLocalStorageUserSession()) as { data?: any };
    const companyId = String(data?.company?.id ?? "");
    const idApp = String(data?.tokens?.username ?? "");
    if (!companyId || !idApp) throw new Error("Faltan companyId o idApp");

    const key = generateS3KeyAuto({
      mimetype: file.type,
      companyId,
      date,
      idApp,
      originalName: file.name,
    })
      .replace(/ /g, "_")
      .trim();

    const presign: PresignResponse = await getPresignedUrl([{ key }]);
    const signedUrl = presign?.urls?.[0]?.url;
    if (!signedUrl) throw new Error("Presigned URL vacío");

    const res = await http.put(signedUrl, file, {
      headers: { "Content-Type": file.type || "application/octet-stream" },
      transformRequest: [
        (data, headers: any) => {
          if (headers) {
            delete headers.Authorization;
            delete headers.common?.Authorization;
          }
          return data;
        },
      ],
      onUploadProgress: (evt) => {
        const total = evt.total ?? file.size ?? 0;
        const loaded = evt.loaded ?? 0;
        const percent = total > 0 ? Math.round((loaded * 100) / total) : 0;
        store.dispatch(setProgress({ key: "upload-global", percent }));
      },
    });

    if (res.status >= 200 && res.status < 300) {
      const url = signedUrl.split("?")[0];
      // store.dispatch(openAlertSuccess({ title: "Subido", subtitle: file.name }));
      return { key, url, etag: res.headers?.etag };
    }
    return null;
  } catch (err: any) {
    // store.dispatch(
    //   openAlertError({ title: "Error al subir", subtitle: err?.message ?? "Error desconocido" })
    // );
    return null;
  } finally {
    store.dispatch(clearProgress({ key: tmpKey }));
    store.dispatch(endGlobalLoading());
  }
};

// store.dispatch(
//   openConfirm({
//     title: "¿Seguro?",
//     subtitle: "Esta acción no se puede deshacer",
//     confirmText: "Sí",
//     cancelText: "No",
//   })
// );
